var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"C-article-headlines"},[(_vm.headlines.length)?[_c('HeadlineBlocks',{attrs:{"data":{ items: _vm.headlines },"settings":_vm.settings,"block-type":"BlockType108"}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }